module.exports = __webpack_public_path__ + "img/cm-simbol.c2c884cc.svg";